/*
Rohini  12/05/2022 2701350359 Added title and content in Dialog Box
Dilip  12/12/2022 2701350359 Added tool tip for close in Dialog Box
Rohini  12/12/2022 2701350359 Added classname for the table
*/
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import reusableInputStyles from '../../components/InputStyles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import {Divider} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import {setAlertData} from '../../redux/reducers/UnsavedChangesAlertReducer';
import {Tooltip} from '@material-ui/core';
function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
export default function UnsavedChangesAlert({value, title = 'Unsaved changes'}) {
  const {showAlert, alertCallback} = useSelector(
    ({unsavedChangesAlert}) => unsavedChangesAlert,
  );
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(
      setAlertData({
        showAlert: false,
        alertCallback: null,
      }),
    );
  };
  const classes = reusableInputStyles();
  return (
    <div>
      <Dialog
        open={showAlert}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="xl"
      >
        <DialogTitle id="draggable-dialog-title" className="alert-popup">
          <div className="dialogue-alert-title">
            <Typography variant="h4">
              {title}
            </Typography>
            <Tooltip title="Close">
              <IconButton aria-label="close" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <Divider />
        <div className={`new-standard-textfields ${classes.dialoguecardStyles}`}>
          <div className="text-center my-3">
            {value ? (
              <Typography variant="h4">{value}</Typography>
            ) : (
              <Typography variant="h4">
                This page contains unsaved changes. Do you still wish to leave this page?
              </Typography>
            )}
          </div>
          <div className="button-table-spacing-mb new-standard-textfields ">
            <>
              <Button
                onClick={handleClose}
                type="button"
                variant="outlined"
                className={`mx-1 search-btn`}
              >
                No
              </Button>
              <Button
                type="submit"
                variant="outlined"
                className={`mx-1 reset-btn`}
                onClick={() => {
                  if (alertCallback) {
                    alertCallback();
                  }
                  handleClose();
                }}
              >
                Yes
              </Button>
            </>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
